import { render, staticRenderFns } from "./CustomerGardenerNotes.vue?vue&type=template&id=979a5562&scoped=true"
import script from "./CustomerGardenerNotes.vue?vue&type=script&lang=js"
export * from "./CustomerGardenerNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979a5562",
  null
  
)

export default component.exports